/**
 * sum for N arrays of possibly different lengths
 * ...sumArrays([0, 1, 2], [1, 2, 3, 4], [1, 2]) // 2 5 5 4
 */
export function sumArrays(...arrays: number[][]): number[] {
  if (arrays) {
    const n = arrays.reduce((max, xs) => Math.max(max, (xs || []).length ? xs.length : 0), 0);
    const result: number[] = [];
    for (let i = 0; i < n; ++i) {
      result.push(+arrays.map((xs) => xs[i] || 0).reduce((sum, x) => sum + x, 0));
    }

    return result;
  } else {
    return [];
  }
}

/**
 * sum array elements
 * sumArray([1, 2, 3, 4]) // 10
 */
export function sumArray(array: number[]): number {
  if (array && array.length > 0) {
    return array.reduce((a: number, b: number) => a + b, 0);
  } else {
    return 0;
  }
}

/**
 * sum array elements
 * averageValueOfTheArray([1, 2, 3, 4]) // 2.5
 */
export function averageValueOfTheArray(array: number[]): number {
  if (array && array.length > 0) {
    return sumArray(array) / array.length;
  } else {
    return 0;
  }
}

/**
 * generate an array of numbers with set min, max and step
 * generateNumbers(50, 100, 10)) // [50, 60, 70, 80, 90, 100]
 */
export function generateNumbers(min: number, max: number, step: number): number[] {
  if (!min || !max || !step) {
    return [];
  }

  const initial = [...Array(max - (min - 1)).keys()];
  const filteredByStep = initial.filter((i) => !(i % Math.round(step)));
  const incrementByMin = filteredByStep.map((v) => min + v);

  return incrementByMin;
}
